import { useStoreState } from '@ariakit/react';
import { Disclosure, DisclosureContent, useDisclosureStore } from '@ariakit/react/disclosure';
import { Spindown } from '#components/atoms/spindown/Spindown.tsx';
import { Timestamp } from '#components/atoms/timestamp/Timestamp.tsx';
import type { AuditLog } from '#dn-types/audit-log.ts';
import { AuditLogChangeSummary } from './change-summary/AuditLogChangeSummary.tsx';
import { AuditLogDescription } from './description/AuditLogDescription.tsx';
import { AuditLogDiff } from './diff/AuditLogDiff.tsx';
import styles from './AuditLogRow.module.css';

type Props = {
  log: AuditLog;
};

/**
 * Row of audit log list, with description, timestamp, and details
 */
export function AuditLogRow({ log }: Props) {
  const disclosure = useDisclosureStore();
  const isOpen = useStoreState(disclosure, 'open');

  return (
    <>
      <h3 className="m-0">
        <Disclosure store={disclosure} className={styles.AuditLogRow}>
          <Spindown className={styles.AuditLogRow_spindownLeft} isExpanded={isOpen} />
          <div className={styles.AuditLogRow_timestampContainer}>
            <div className={styles.AuditLogRow_timestamp}>
              [<Timestamp datetime={log.timestamp} />]
            </div>
            <div className={styles.AuditLogRow_content}>
              <AuditLogDescription log={log} />
              <AuditLogChangeSummary log={log} />
            </div>
          </div>
          <Spindown className={styles.AuditLogRow_spindownRight} isExpanded={isOpen} isMobile={true} />
        </Disclosure>
      </h3>
      <DisclosureContent store={disclosure}>
        <AuditLogDiff log={log} />
      </DisclosureContent>
    </>
  );
}
